import { Injectable } from '@angular/core';
import { Basket as CoreBasket } from '@df/session/api/basket/basket';
import { BasketItem } from '@df/session/api/basket/basket-item';
import keys from 'lodash-es/keys';
import pick from 'lodash-es/pick';
import values from 'lodash-es/values';
export interface IFreeshipping {
    [method: string]: boolean;
}
export interface IFreeshippingminamounts {
    [method: string]: IFreeshippingminamount;
}
export interface IFreeshippingminamount {
    name: string;
    value: number;
}
declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.Basket {
        interface BasketData {
            freeshippingminamounts?: IFreeshippingminamount[];
            freeshipping?: IFreeshipping;
        }
    }
}
@Injectable({
    providedIn: 'root'
})
export class LocalBasket extends CoreBasket {
    freeShippingRules: IFreeshippingminamount[] = [];
    override onDataUpdate(items: BasketItem[]): void {
        super.onDataUpdate(items);
        this.freeShippingRules =
            this.data.freeshippingminamounts && this.data.freeshipping
                ? values(pick(this.data.freeshippingminamounts, keys(this.data.freeshipping))).filter(i => i) as IFreeshippingminamount[]
                : [];
    }
}
